import styled from 'styled-components'

import { ListItem as SharedListItem, OptionsItem as SharedOptionsItem } from './../List/list.styles'

export const ListItemCollapsedWrapper = styled(SharedListItem)``

export const OptionsItem = styled(SharedOptionsItem)`
    justify-content: center;
    text-decoration: none;
    font-size: 12px;
`
